import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';
import { Row } from '../../../base/Grid/grid';

import {
  ColContentContainerStyled,
  ColIconContainerStyled,
  IconStyled,
  LinkStyled,
  ProductResourceCalloutContainer,
  TypographyStyled,
} from './styles';

export const ProductResourceCalloutComponent = ({
  ariaLabel,
  icon,
  linkId,
  linkPath,
  linkText,
  text,
}) => (
  <ProductResourceCalloutContainer>
    <Row align='center'>
      <ColIconContainerStyled xsmall={2} small={1}>
        <IconStyled variant={icon} />
      </ColIconContainerStyled>
      <ColContentContainerStyled xsmall={10} small={11}>
        <TypographyStyled component='p'>
          {text}
        </TypographyStyled>
        <LinkStyled
          id={linkId}
          href={linkPath}
          variant='secondary'
          aria-label={ariaLabel}>
          {linkText}
        </LinkStyled>
      </ColContentContainerStyled>
    </Row>
  </ProductResourceCalloutContainer>
);

ProductResourceCalloutComponent.propTypes = {
  ariaLabel: PropTypes.string,
  icon: PropTypes.string.isRequired,
  linkId: PropTypes.string.isRequired,
  linkPath: PropTypes.string.isRequired,
  linkText: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};

export default withTheme(ProductResourceCalloutComponent);
